import styled from 'styled-components';
import HappySearchSvg from './happySearch.svg';

const HappySearchIcon = styled(HappySearchSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '1.5rem'};
  height: ${props => props.height || '1.5rem'};
  margin: ${props => props.margin};
  fill: ${props => props.fill || props.theme.colors.ash.base};
`;

export default HappySearchIcon;
